module.exports = __webpack_public_path__ + "static/media/RA_V2.6d162c76.gif";